import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Svg } from './Svg.js';
import CSSTransitionGroup from './external-adapters/reactTransitionGroupAdapter.tsx';

// Defined above
// eslint-disable-next-line no-undef

export const LightBoxWrapper = createReactClass({
    /**
     * 1) Use "fixed" only for small amounts of content where scrolling isn't needed to see the bottom of the lightbox
     * 2) LightBoxWrapper DOES NOT UNMOUNT -- the parent/caller should pass in "unMountHandler".
     * 3) the parent/caller should use the "closeLightbox" prop to invoke css fadeout before closing.
     */
    propTypes: {
        fixed: PropTypes.bool,
        unMountHandler: PropTypes.func.isRequired,
        closeLightbox: PropTypes.bool,
        // If frameless is true, users can only close this lightbox by clicking elsewhere on the page.
        frameless: PropTypes.bool,
        // If viewportPositioned is true, the position of this new lightbox will
        // be determined by the user's scroll-position when the lightbox opened.
        // (Otherwise, it's determined by the lightbox's position within the DOM.)
        viewportPositioned: PropTypes.bool,

        additionalClasses: PropTypes.string,
    },

    getDefaultProps: function () {
        return {
            fixed: false,
            closeLightbox: false,
            viewportPositioned: false,
        };
    },

    getInitialState: function () {
        return {
            items: (this.props.closeLightbox) ? [] : ['lightbox-wrapper-contents'],
            itemWithFocus: $('input:focus').not('.overlay-iframe-wrapper input:focus'),
        };
    },

    UNSAFE_componentWillReceiveProps: function (newProps) {
        if (newProps.closeLightbox != this.props.closeLightbox && newProps.closeLightbox) {
            var component = this;
            setTimeout(function () { component.lightboxCloseHandler(); }, 500);
        }
    },

    componentDidMount: function () {
        if (this.props.viewportPositioned) {
            const scrollPosition = $(window).scrollTop();

            // "top" value determines offset *from positioned ancestor*. If we want to position relative to the window,
            // we have to subtract out that offset.
            let ancestorPosition = 0;
            if (this.dom) {
                ancestorPosition = $(this.dom).offsetParent().offset().top;
            }

            const top = scrollPosition - ancestorPosition;
            this.setState({ top });
        }

        if (this.state.itemWithFocus && this.state.itemWithFocus.length > 0) {
            if (this.props.closeLightbox) {
                this.state.itemWithFocus.get(0).focus();
            } else {
                this.state.itemWithFocus.get(0).blur();
            }
        }
    },

    componentWillUnmount: function () {
        if (this.state.itemWithFocus && this.state.itemWithFocus.length > 0) {
            this.state.itemWithFocus.get(0).focus();
        }
    },

    lightboxCloseHandler: function (event) {
        if (event) event.preventDefault();
        this.setState({
            items: [],
        });
        var component = this;
        setTimeout(function () { component.props.unMountHandler(); }, 500);
    },

    render: function () {
        var items = this.state.items.map(function (item, i) {
            var overlay;
            if (this.props.frameless) {
                overlay = null;
            } else {
                overlay = (
                    <div className="overlay-close">
                        <a tabIndex="0" href="" aria-label="close" onClick={this.lightboxCloseHandler}>
                            <Svg icon="delete" additionalClasses="is-button" attributes={{ role: 'presentation' }}/>
                        </a>
                    </div>
                );
            }

            const style = this.state.top === undefined ? {} : { top: this.state.top };
            // "js-react" is used to ensure that editing photos doesn't automatically remove this lightbox
            var overlayClassNames = 'overlay-iframe-wrapper large js-react ' +
                    ((this.props.fixed) ? 'fixed ' : '') +
                    ((this.props.additionalClasses) ? `${this.props.additionalClasses} ` : '') +
                    'on';
            return (
                <div className='overlay-container' key={item} ref={(dom) => this.dom = dom}>
                    <div onClick={this.lightboxCloseHandler} className="screen on"/>
                    <div className={overlayClassNames} style={style}>
                        {overlay}
                        {this.props.children}
                    </div>
                </div>
            );
        }.bind(this));
        return (
            <CSSTransitionGroup
                transitionName="dc-lightbox-wrapper"
                transitionAppear={true}
                transitionEnter={false}
                transitionAppearTimeout={300}
                transitionLeaveTimeout={300}
                transitionEnterTimeout={10}
            >
                {items}
            </CSSTransitionGroup>
        );
    },
});
